import { render, staticRenderFns } from "./matchHDPOU1X2FTOdds.vue?vue&type=template&id=e817d48a&lang=pug&"
import script from "./matchHDPOU1X2FTOdds.vue?vue&type=script&lang=js&"
export * from "./matchHDPOU1X2FTOdds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports